"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pipeWith = _interopRequireDefault(require("./pipeWith"));

var _default = function _default(condition) {
  for (var _len = arguments.length, funcs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    funcs[_key - 1] = arguments[_key];
  }

  return function (value) {
    if (funcs.length === 0 || !condition(value)) {
      return value;
    }

    return _pipeWith.default.apply(void 0, [value].concat(funcs));
  };
};

exports.default = _default;